import { create } from "zustand";

interface AppState {
  modalOpen: boolean;
  message: string;
  waitTime: { hours: number; minutes: number };
  showWaitTimeInput: boolean; 
  setModalOpen: (isOpen: boolean) => void;
  setMessage: (message: string) => void;
  setWaitTime: (hours: number, minutes: number) => void;
  setShowWaitTimeInput: (show: boolean) => void; 
  confirmAction: any;
  setConfirmAction: (confirmAction: any) => void;
}

export const useModalConfirmActionStore = create<AppState>((set) => ({
  modalOpen: false,
  message: '',
  waitTime: { hours: 0, minutes: 0 },
  showWaitTimeInput: false, 
  setModalOpen: (isOpen) => set({ modalOpen: isOpen }),
  setMessage: (message) => set({ message, showWaitTimeInput: false }),
  setWaitTime: (hours, minutes) => set({ waitTime: { hours, minutes } }),
  setShowWaitTimeInput: (show) => set({ showWaitTimeInput: show }), 
  confirmAction: () => {},
  setConfirmAction: (confirmAction) => set({ confirmAction })
}));